import { orderByFrequency } from '../relevancyScoreUtils';
import { getDataTypeFamiliesFromReport } from './dataTypeFamilyDerivationUtils';
import { DATA_TYPE_HUBS } from '../../../constants/recommendations/DataTypeHubs';
export const getHubsFromReport = report => {
  const dataTypes = getDataTypeFamiliesFromReport(report);
  const hubCounts = dataTypes.reduce((acc, dataType) => {
    const dataTypeHubs = DATA_TYPE_HUBS[dataType] || [];
    dataTypeHubs.forEach(hub => {
      acc[hub] = (acc[hub] || 0) + 1;
    });
    return acc;
  }, {});
  const maxCount = Math.max(...Object.values(hubCounts));
  const prevalentHubs = Object.keys(hubCounts).filter(hub => hubCounts[hub] === maxCount);
  return orderByFrequency(prevalentHubs);
};
export const getHubsFromReports = reports => {
  const hubs = reports.reduce((acc, report) => {
    const reportHubs = getHubsFromReport(report);
    if (reportHubs) {
      acc.push(...reportHubs);
    }
    return acc;
  }, []);
  return orderByFrequency(hubs);
};
export const getHubsFromDashboardTemplate = template => {
  const widgets = template.get('widgetTemplates');
  const reportTemplates = widgets.map(widget => widget.get('reportTemplate'));
  return getHubsFromReports(reportTemplates);
};